import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'toggleButton', 'toggleButtonLabel'];
  static values = {
    maxLines: { type: Number, default: 3 },
    moreLabel: { type: String, default: 'More' },
    lessLabel: { type: String, default: 'Less' },
  };
  connect() {
    this.toggle(false)
    this.hideButtonIfNotNeeded()
    this.resizeObserver = new ResizeObserver(() => this.hideButtonIfNotNeeded())
    this.resizeObserver.observe(this.contentTarget)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  hideButtonIfNotNeeded() {
    if (!this.hasToggleButtonTarget) return;

    const content = this.contentTarget;
    if (content.classList.contains('line-clamp-none')) return;

    const isOverflowing = content.scrollHeight > content.clientHeight;

    if (!isOverflowing) {
      this.toggleButtonTarget.classList.add('hidden');
    } else {
      this.toggleButtonTarget.classList.remove('hidden');
    }
  }

  toggle(hideIfShown = true) {
    const content = this.contentTarget;
    const isExpanded = content.classList.contains('line-clamp-none');

    const lineClampClass = `line-clamp-${this.maxLinesValue}`;

    if (isExpanded || !hideIfShown) {
      content.classList.remove('line-clamp-none');
      content.classList.add(lineClampClass);
      this.toggleButtonLabelTarget.textContent = this.moreLabelValue;
    } else {
      this.toggleButtonLabelTarget.textContent = this.lessLabelValue;
      content.classList.remove(lineClampClass);
      content.classList.add('line-clamp-none');
    }
  }
}
